"use client";

import { useUrlDrawer } from "@nimble/react-state-hooks/use-url-drawer";

export default function useSignInDrawer() {
  return useUrlDrawer({
    paramName: "signin",
  });
}
